// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__3LZQb","track":"Slider_track__zh1IJ","thumb":"Slider_thumb__eE-Kt"};